import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  height: calc(100vh - 117px);
  width: calc(100vw - 60px);
  position: fixed;
  left: 60px;
  top: 117px;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mediaMaxWidth.tablet} {
    top: 0;
    height: 100vh;
    z-index: 5;
    left: 0;
    width: 100vw;
  }

  ${mediaMaxWidth.phone} {
    top: 55px;
  }
`;

export const ModalWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 650px;
  height: 470px;
  z-index: 5;
  padding: 10px 20px;
  position: relative;
  box-shadow: rgb(142, 142, 142) 0px 0px 15px;
  overflow: hidden;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.fadeInDown {
    animation-name: fadeInDown;
  }

  &.delay {
    animation-delay: 1.2s;
  }

  &.animated {
    animation-duration: 0.5s !important;
    animation-fill-mode: both;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
  }

  ${mediaMaxWidth.phone} {
    position: absolute;
    top: 10px;
    height: unset;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.phone} {
    margin: 2px 0 7px 0;
  }
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModalBody = styled.div`
  display: flex;
  height: calc(100% - 55px);
  flex-direction: column;
  justify-content: space-evenly;

  a {
    text-align: center;
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 0;
  }
`;

export const BodyTitle = styled.div`
  width: 90%;
  margin: 0 auto;
  font-weight: 700;
  text-decoration: underline;
  text-align: center;

  ${mediaMaxWidth.phone} {
    width: 100%;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.75em;
  }
`;

export const BodyText = styled.div`
  width: 90%;
  margin: 0 auto;
  font-size: 0.9em;
  font-style: italic;

  ${mediaMaxWidth.phone} {
    width: 100%;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.75em;
  }
`;

export const List = styled.div`
  margin: 30px 0 50px 0;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth.phone} {
    margin: 10px 0 20px 0;
  }
`;

export const ListItems = styled.div`
  width: 440px;
`;

export const ListItem = styled.div`
  margin: 10px 0;
  display: flex;
  align-items: center;
  font-size: 1em;
  font-style: normal;

  svg {
    margin-right: 15px;
    color: #f2008c;
    font-size: 1.4em;
  }

  ${mediaMaxWidth.phone} {
    margin: 10px 0;
    font-size: 0.9em;
    justify-content: flex-start;

    svg {
      font-size: 1.2em;
    }
  }
`;

export const CallInfo = styled.div`
  width: 90%;
  margin: 0 auto;
  text-align: center;

  ${mediaMaxWidth.phone} {
    width: 100%;
    font-size: 0.9em;
  }

  ${mediaMaxWidth.smallPhone} {
    font-size: 0.75em;
  }
`;

export const CallLink = styled.a`
  cursor: pointer;
  color: #333 !important;
  text-decoration: underline !important;

  &:hover {
    color: #f2008c !important;
  }
`;
